import { mapGetters, mapActions } from 'vuex'
import { formatNumber } from '@/util/formatters'
export default {
    data: () => {
        return {
            selectedGadget: null
        }
    },
    computed: {
        ...mapGetters([
            'selectedClaim'
        ]),
        policyDetails() {
            return this.selectedClaim.policyDetails
        },
        coverLimitForSelectedGadget() {
            return this.getCoverLimit(this.selectedGadget)
        }
    },
    methods: {
        ...mapActions({
            fetchGadgets: 'fetchGadgetsForClaim'
        }),
        getCoverLimit(gadget) {
            //console.log('-g: ', gadget)
            //console.log('-g id: ', gadget.id)
            //console.log('-c: ', this.selectedClaim)
            if (this.policyDetails.policyRatingTypeId == 1 && gadget) {
                const gdt = this.selectedClaim.gadgetDetails.find(g => g.id == gadget.id)

                return formatNumber(2)(gdt.value)
            } else {
                if (this.policyDetails.policyRatingTypeId == 2) {
                    if (this.policyDetails.sal) {
                        return formatNumber(2)(this.policyDetails.sal)
                    } else {
                        return formatNumber(2)(this.policyDetails.coverLimit)
                    }
                }
                return 0
            }
        },
        isOverCoverLimit(amount,gadget) {
            return amount > this.getCoverLimit(gadget)
        },
        isOverCoverLimitForSelectedGadget(amount) {
            try {
                return amount > this.coverLimitForSelectedGadget
            } catch {
                return false
            }
        },
        loadGadgetDetails() {
            if (this.selectedClaim) {
                if (!this.selectedClaim.gadgetDetails || this.selectedClaim.gadgetDetails.length == 0) {
                    this.fetchGadgets(this.selectedClaim.claimId)
                }
            }
        }
    },
    beforeMount() {
        this.loadGadgetDetails()
    }
}